import { createAction } from '@kistler/skybase-ui/skybase-core/base/create-action'
import { getActionName } from '@kistler/skybase-ui/skybase-core/utils/get-action-name'

export const SHOW_ONLY_ACTIVE_CHANNELS = getActionName('SHOW_ONLY_ACTIVE_CHANNELS')
export const showOnlyActiveChannels = isShowOnlyActiveChannels =>
  createAction(SHOW_ONLY_ACTIVE_CHANNELS, { isShowOnlyActiveChannels })
